export default __webpack_public_path__ + "static/media/mappin_red.fa58c14b.svg";